export function pickString(...vals: unknown[]): string | undefined {
  for (const v of vals) {
    if (typeof v === "string" && v.trim()) return v.trim();
    if (typeof v === "number" && Number.isFinite(v)) return String(v);
  }
  return undefined;
}

export function pickNestedName(value: unknown): string | undefined {
  if (typeof value === "string") return pickString(value);
  if (value && typeof value === "object" && value !== null) {
    const rec = value as Record<string, unknown>;
    return pickString(rec.name, rec.display_name, rec.company_name, rec.label);
  }
  return undefined;
}

/** Normalize Dexwork collection or record payloads from edge functions. */
export function extractCollectionResults(payload: unknown): Array<Record<string, unknown>> {
  if (!payload || typeof payload !== "object") return [];
  const root = payload as Record<string, unknown>;
  if (root.type === "collection" && Array.isArray(root.results)) {
    return root.results as Array<Record<string, unknown>>;
  }
  if (Array.isArray(root.results)) {
    return root.results as Array<Record<string, unknown>>;
  }
  if (root.data && typeof root.data === "object") {
    return extractCollectionResults(root.data);
  }
  return [];
}

export function formatByteSize(size: number): string {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  return `${(size / (1024 * 1024)).toFixed(2)} MB`;
}
